import 'css-chunksrc/client/pages/projectPage/discussionsPage/styles.scss';export default {
  "discussionsPage": "_discussionsPage_1lhlq_1",
  "header": "_header_1lhlq_9",
  "main": "_main_1lhlq_16"
};